
import * as Print from 'expo-print';
import * as Sharing from 'expo-sharing';
import { Platform } from 'react-native';

export const _print = async (html: string) => {
    return Platform.select({
        // On iOS/android prints the given html.
        native: () => {
            Print.printAsync({ html });
        },
        // On web prints the HTML from the current page.
        default: () => {
            const printWindow = window.open('', '_blank');
            if (printWindow) {
                const doc = printWindow.document;
                // Open the document and create a blank page first
                doc.open();
                doc.close();
                // Write the HTML into the document
                doc.documentElement.innerHTML = html;
                // Print it
                printWindow.focus();
                printWindow.print();
                printWindow.close();
            } else {
                alert('Popup blocked! \nPlease allow popups to print the document.');
            }
        }
    })();
};



export  const _share = async (htmlForNative: string, pdfDataURIForWeb: string) => {
    return Platform.select({
        // Android or iOS
        native: async () => {
            // On iOS/android prints the given html.
            // On web prints the HTML from the current page.
            const { uri } = await Print.printToFileAsync({ html: htmlForNative });
            console.log('File has been saved to:', uri);
            await Sharing.shareAsync(uri, { UTI: '.pdf', mimeType: 'application/pdf' });
        },
        // Web
        default: async () => {
            // Note: HTML2PDF is loaded inside the template
            try {
                // Document file name
                const filename = 'document.pdf';
                // Convert base64 to binary data
                const response = await fetch(pdfDataURIForWeb as string);
                // Create blob from binnary data
                const blob = await response.blob();
                // Create a file from blod
                const file = new File([blob], filename, { type: 'application/pdf', });
                // Share the document file
                await navigator.share({
                    title: 'Share document',
                    text: 'Here is a PDF version of your document',
                    files: [file],
                });
            } catch (error) {
                console.error('Error while trying to share the document:', error);
                alert(`${error}`);
            }
        }
    })();
};